module.exports = {
  title: 'Linear Sensors with Skia and Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2024-11-26',
  slug: 'linear-sensors',
  tags: ['skia', 'reanimated'],
};
